import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { CONSTANTS } from 'config/constants';
import BtnListTypeSetting from 'components/property-settings/btn-list-type-setting/btn-list-type-setting';
import { PropertyBox, PropertyLabel } from 'components/property-settings/property-shared-styles';
import { Box, Typography } from '@mui/material';

type FacialLoopProps = {
    handleSettings: (propertyName: string, settingValue: string) => void;
    facialLoop: string;
    options?: string[];
    isRequired?: boolean;
};

const FacialLoop: FC<FacialLoopProps> = ({ handleSettings, facialLoop, options, isRequired }: FacialLoopProps) => {
    const { t: translate } = useTranslation(['construction-props']);

    return (
        <PropertyBox>
            <Box display="flex">
                <PropertyLabel variant="h5">{translate('FACIAL_LOOP')}</PropertyLabel>
                {isRequired && (
                    <Typography
                        component="span"
                        color="error"
                        fontSize={18}
                        sx={{ marginLeft: '2px', marginTop: '-5px' }}
                    >
                        *
                    </Typography>
                )}
            </Box>
            <BtnListTypeSetting
                setting={options ? options : CONSTANTS.FACIAL_LOOP}
                propertyName="facialLoop"
                settingValue={facialLoop}
                handlePropertySelection={handleSettings}
            />
        </PropertyBox>
    );
};

export default FacialLoop;
